document.addEventListener('DOMContentLoaded', () => {
  const administratorsTable = document.querySelector('.administrators-table');

  if (!administratorsTable) return;

  const allCells = administratorsTable.querySelectorAll('td, th');
  let currentHighlightedCells = [];

  const clearHighlight = () => {
    currentHighlightedCells.forEach(cell => {
      cell.classList.remove('row-highlight', 'col-highlight', 'cell-hover');
    });
    currentHighlightedCells = [];
  };

  const highlightRowAndColumn = (targetCell) => {
    clearHighlight();

    const row = targetCell.parentElement;
    const cellIndex = Array.from(row.children).indexOf(targetCell);

    row.querySelectorAll('td, th').forEach(cell => {
      cell.classList.add('row-highlight');
      currentHighlightedCells.push(cell);
    });

    administratorsTable.querySelectorAll('tr').forEach(tr => {
      const cell = tr.children[cellIndex];
      if (cell) {
        cell.classList.add('col-highlight');
        currentHighlightedCells.push(cell);
      }
    });
  };

  allCells.forEach((cell) => {
    cell.addEventListener('mouseenter', () => highlightRowAndColumn(cell));
  });

  administratorsTable.addEventListener('mouseleave', clearHighlight);

  administratorsTable.querySelectorAll('tbody td').forEach((cell) => {
    const checkbox = cell.querySelector('input[type="checkbox"]');
    if (!checkbox) return;

    cell.addEventListener('click', (e) => {
      if (e.target === checkbox) return;

      checkbox.checked = !checkbox.checked;

      const event = new Event('change', { bubbles: true });
      checkbox.dispatchEvent(event);
    });
  });
});
